import React from 'react';
import LoginForm from '@/components/auth/LoginForm';

const LoginPage: React.FC = () => {
  return <LoginForm data-id="xvba7kwpc" data-path="src/pages/LoginPage.tsx" />;
};

export default LoginPage;